import * as React from "react";
import styleable from "react-styleable";

const inputStyle = require('../../../css/components/mainlayout/PortalInput.css');

/**
 * The MappedInput uses its internal state to keep track of what is displayed in the input box, but changes to the value prop override the internal value.
 * 
 * ## styleable
 * * **label** Styling for the label.
 * * **input** Styling for the input box.
 * * **type** Otional input type.
 *
 * ## CSS styling
 * * **.wcrc-textinput** override styling of the text input (also affects styling of text input in pages/mainlayout)
 */
class MappedInput extends React.Component<any, any> {

    constructor(_){
        super(_);
        this.state = {
            viewValue: null,
        }
    }

    componentDidUpdate(prevProps){
        if(prevProps.value !== this.props.value)
            this.setState({viewValue: null}); // Reset viewValue when master value changes
    }

    render() {

        let val = this.state.viewValue;
        if(val === null)
            val = this.props.value;

        return (
            <span>
                <i className={this.props.css.label}>{this.props.placeholder}</i>
                <input type={this.props.type ? this.props.type : "text"} className={"wcrc-textinput " + this.props.css.input} placeholder={this.props.placeholder} value={val} onChange={(e) => {
                    if(this.props.onChange !== undefined){
                        this.props.onChange(e.target.value);
                    }
                    this.setState({viewValue: e.target.value});
                }} onBlur={(e)=>{
                    if(this.props.onBlur !== undefined){ 
                        this.props.onBlur(e.target.value);
                    }
                    this.setState({viewValue: null});
                }}/>
            </span>
        );
    }
}
export default styleable(inputStyle)(MappedInput);